import "./polyfill";
import { initCinema } from "./init";
import Logger from "./logger";

window.o_global.eventQBus.on("ft3bcn.combo-combolist.init", () => {
  Logger.group("[FT3BCN combo combolist]");
  Logger.count("Combolist Invocation");
  initCinema();
  Logger.groupEnd();
});
